// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__13hOu","name":"ConsentHeader_name__2fyof","birthday":"ConsentHeader_birthday__2wa9R","skeleton":"ConsentHeader_skeleton__2KicS"};